export default __webpack_public_path__ + "02de2853e01a0f8dd9dbd9811c963f20.png";